import { UserIdSchema } from "@core/domains/identity";
import { identity } from "@core/foundation/function";
import {
  createModel,
  createModelSchemas,
  noModelUpdate,
} from "@core/foundation/model";
import { z } from "@core/zod";

import { GridEpochIdSchema } from "./epoch.ts";

export const GridConfig = createModel({
  create: (item, schema) => {
    return { ...schema.decode(item) };
  },
  schemas: createModelSchemas({
    base: z.object(
      {
        gridEpochId: GridEpochIdSchema,
        squareKcal: z.int().positive(),
        userId: UserIdSchema,
      },
      {
        gridEpochId: "The grid epoch the configuration applies to.",
        squareKcal: "The kcal one square of the grid stands for.",
        userId: "The id of the user the configuration belongs to.",
      },
    ),
    derive: { create: identity, recovery: identity, update: noModelUpdate },
  }),
  update: (item, update, schema) => {
    return { ...item, ...schema.decode(update) };
  },
});

export interface GridConfig extends z.infer<typeof GridConfig.schema> {}
